import { Selecting, useToastProvider } from '@qualio/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentStatus } from '../../../../../../../../api/model/document';
import { useTableDataInvalidation } from '../../../../hooks/useTableDataInvalidation';
import { WorkspaceTabs } from '../../../../WorkspaceV2';
import {
  hasAllowedStatusesForAction,
  hasRequiredPermissionsForAction,
} from '../../../BulkActions';
import { BulkActionButton } from '../../BulkActionButton/index';
import { handleStatusChange } from '../ChangeStatusService';
import {
  ChangeStatusButtonProps,
  IsChangeStatusActionAllowedCallback,
} from '../types';

export const RevertToDraftButton = (props: ChangeStatusButtonProps) => {
  const { t } = useTranslation();
  const { showToast } = useToastProvider();
  const [isLoading, setIsLoading] = useState(false);
  const selection = Selecting.useSelectionMaybe();
  const { invalidate } = useTableDataInvalidation();
  const toastActionStringActive = t('buttons.revertToDraft').toLowerCase();
  const toastActionStringPassive = t('success.successfullyRevertedToDraft')
    .toLowerCase()
    .replace('successfully ', '')
    .replace(' document to draft', ' to draft');

  const handleRevertToDraft = async () => {
    setIsLoading(true);
    await handleStatusChange(
      props.selectedDocuments,
      { status: DocumentStatus.Draft },
      selection?.setSelection as any,
      showToast,
      toastActionStringActive,
      toastActionStringPassive,
    );
    setIsLoading(false);
    void invalidate(props.currentTab);
  };

  const canRevertToDraft: IsChangeStatusActionAllowedCallback = (
    user,
    statuses,
    activeTab,
    requiredPermissions,
  ) => {
    if (
      !hasRequiredPermissionsForAction(requiredPermissions, user.permissions)
    ) {
      return false;
    }

    switch (activeTab) {
      case WorkspaceTabs.YOUR_DOCUMENTS:
        return hasAllowedStatusesForAction(
          [
            DocumentStatus.For_Review,
            DocumentStatus.For_Approval,
            DocumentStatus.Approval_Declined,
          ],
          statuses,
        );
      case WorkspaceTabs.ALL_DOCUMENTS:
        return hasAllowedStatusesForAction(
          [DocumentStatus.For_Review, DocumentStatus.For_Approval],
          statuses,
        );
      default:
        return false;
    }
  };

  return (
    <BulkActionButton
      {...props}
      isActionAllowed={canRevertToDraft}
      onClick={handleRevertToDraft}
      isLoading={isLoading}
    />
  );
};
